import React from 'react'
import classes from 'classnames'

import styles from './Button.module.scss'

interface ButtonPropsType {
  active: boolean,
  className?: string,
  disabled: boolean,
  link?: string,
  onClick: (e: object) => void,
  onHover?: (e: object) => void,
  text: string,
  type?: string
}

const Button = (props: ButtonPropsType) => {
  const {
    active = false,
    disabled = false,
    className = '',
    link = '',
    onClick = () => {},
    text = '',
    type = 'Round'
  } = props

  const buttonClasses = classes(styles[`button${type}Component`], {
    [styles[`button${type}ComponentActive`]]: active,
    [styles[`button${type}ComponentDisabled`]]: disabled
  }, className)

  if (link.length) { return (<a className={buttonClasses} href={link}>{text}</a>) }
  return (
    <button
      className={buttonClasses}
      disabled={disabled}
      onClick={onClick}>{text}</button>
  )
}

export default Button;
